export const APIMapper = {
    FACEBOOK_GET_LOGIN:"utility/facebook_login",
    FACEBOOK_LOGIN:"facebook/login?code=",
}